import React, { useState, forwardRef, useMemo } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Typography,
    ListSubheader,
    TextField,
    InputAdornment,
    InputLabel
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllCategories } from 'src/services/feedbackService';
import '../Feedback.css';

interface categoryDropdownProps {
    value: number;
    onChange: (e: any) => void;
    disabled?: boolean;
    required?: boolean;
    label?: string
}

const CategorySelectDropdown = forwardRef((props: categoryDropdownProps, _ref) => {
    const [list, setList] = useState([]);
    const [searchText, setSearchText] = useState<string>('');

    const fetchCategories = (searchText) => {
        getAllCategories().then((res) => {
            setList(res?.data?.data.filter((option) => containsText(option?.category, searchText)));
        });
    }

    const containsText = (text, searchText) =>
        text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;


    React.useEffect(() => {
        fetchCategories(searchText);
    }, []);

    const filteredLists = useMemo(
        () =>
            list.length > 0 &&
            list?.filter((option) => containsText(option?.category, searchText)),
        [list, searchText]
    );

    return (
        <FormControl
            fullWidth
            disabled={props?.disabled ? props?.disabled : false}
            className="task-type-dropdown"
        >

            {props?.label && (<InputLabel
                style={{
                    fontSize: '12px'
                }}
            >
                {props?.label}
            </InputLabel>)}
            <Select
                sx={{ mt: '4px' }}
                style={{
                    fontSize: '12px',
                    height: '2rem',
                    marginTop: '8px'

                }}
                displayEmpty
                size="small"
                value={props?.value ? props?.value : ""}
                onChange={(e) => { props?.onChange(e) }
                }
            >
                {!props?.label && (<MenuItem style={{ display: 'none' }} selected disabled value={''}>
                    Select Category
                </MenuItem>
                )}
                <ListSubheader>
                    <TextField
                        id="employee-id"
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                                e.stopPropagation();
                            }
                        }}
                    ></TextField>
                </ListSubheader>
                {filteredLists?.length > 0 &&
                    filteredLists.map((type, i) => {
                        return (
                            <MenuItem key={i} value={type.id}>
                                <ListItemText primary={type.category} />
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
});

export default CategorySelectDropdown;
